import { Link, Text } from '@podiumhq/design-system';
import {
  PODIUM_PRIVACY_POLICY_URL,
  PODIUM_TERMS_AND_CONDITIONS_URL,
} from 'routes/constants';
import { SelectPlanCheckoutButton } from '../styles';

const linkStyles = { color: 'blue.base', isExternal: true };

const SelectPlanPurchase = ({
  buttonLabel = 'Complete your purchase',
  displayDisclaimer = true,
  price,
  submitPurchase,
  term = 'month',
  ...buttonProps
}) => (
  <>
    {displayDisclaimer && (
      <Text
        color="black.lightest"
        fontSize="sm"
        fontWeight="normal"
        lineHeight="20px"
        my="24px"
      >
        By clicking “{buttonLabel},” you agree that you have read and accept the{' '}
        <Link href={PODIUM_TERMS_AND_CONDITIONS_URL} {...linkStyles}>
          Podium Terms of Service,
        </Link>{' '}
        <Link href={PODIUM_PRIVACY_POLICY_URL} {...linkStyles}>
          Privacy Policy,
        </Link>{' '}
        and these terms: Beginning on the date of purchase your credit/debit
        card will be charged ${price}/{term} + taxes until you cancel. Cancel at
        anytime in Settings > Billing. If you cancel, your plan will end at the
        close of your current billing period.
      </Text>
    )}

    <SelectPlanCheckoutButton
      fillColor="blue.base"
      margin="12px 0 20px 0"
      onClick={submitPurchase}
      width="100%"
      {...buttonProps}
    >
      {buttonLabel}
    </SelectPlanCheckoutButton>
  </>
);

export default SelectPlanPurchase;
